import React from 'react';
import { Form } from 'components/atoms';
import { Formik, Field } from 'formik';
import { FieldCustom } from 'components/molecules';
import * as Yup from 'yup';

const TimelySchema = Yup.object().shape({ url: Yup.string() })

const TimelyEditor = ({ initialProps, onChange }) => {

  const handleFormChange = (newValues) => {
    const newProps = {
      ...initialProps, ...newValues
    };
    onChange(newProps);
  }

  return (
    <div>
      <Formik
        initialValues={{
          identifier: initialProps.identifier,
        }}
        validationSchema={TimelySchema}
        validate={handleFormChange}
      >
        <Form>
          <Field
            title="Identificador"
            name="identifier"
            component={FieldCustom}
            maxLetters={20}
          />
        </Form>
      </Formik>
    </div>
  );
};

export default TimelyEditor;
